import React from 'react'
import { Link } from 'react-router-dom'
import Typography from 'material-ui/Typography'
import Tooltip from 'material-ui/Tooltip'
import { withStyles } from 'material-ui/styles'
import styles from './styles'

const TestsRowLink = props => {
  const { link, title, classes } = props
  return (
    <Tooltip
      title={typeof title === 'undefined' ? '' : title}
      classes={{ tooltip: classes.lightTooltip }}
      enterDelay={700}
      placement='bottom'
    >
      <Typography component={Link} to={link}>
        {title}
      </Typography>
    </Tooltip>
  )
}

export default withStyles(styles)(TestsRowLink)



// WEBPACK FOOTER //
// ./src/components/table/cells/testsRowLink/index.js